<div *ngIf="isOpen"
     class="chat-modal"
     [ngStyle]="combinedStyle"
     role="dialog"
     aria-modal="true"
     [attr.aria-label]="headerTitle">

  <!-- Resize handles: edges -->
  <div class="chat-modal__resize chat-modal__resize--n"  (mousedown)="startResize($event, 'n')"></div>
  <div class="chat-modal__resize chat-modal__resize--s"  (mousedown)="startResize($event, 's')"></div>
  <div class="chat-modal__resize chat-modal__resize--e"  (mousedown)="startResize($event, 'e')"></div>
  <div class="chat-modal__resize chat-modal__resize--w"  (mousedown)="startResize($event, 'w')"></div>
  <!-- Resize handles: corners -->
  <div class="chat-modal__resize chat-modal__resize--ne" (mousedown)="startResize($event, 'ne')"></div>
  <div class="chat-modal__resize chat-modal__resize--nw" (mousedown)="startResize($event, 'nw')"></div>
  <div class="chat-modal__resize chat-modal__resize--se" (mousedown)="startResize($event, 'se')"></div>
  <div class="chat-modal__resize chat-modal__resize--sw" (mousedown)="startResize($event, 'sw')"></div>

  <!-- Drag handle / header -->
  <div class="chat-modal__header" (mousedown)="startDrag($event)">
    <img *ngIf="logoUrl"
         [src]="logoUrl"
         class="chat-modal__logo"
         alt="Logo"
         aria-hidden="true" />
    <span *ngIf="!logoUrl" class="chat-modal__icon" aria-hidden="true">✦</span>
    <span class="chat-modal__title">{{ headerTitle }}</span>
    <button type="button"
            class="chat-modal__close"
            (click)="close()"
            aria-label="Cerrar chat">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Chat content -->
  <div class="chat-modal__content">
    <app-chat-drawer></app-chat-drawer>
  </div>
</div>
